import { createSelector } from "@ngrx/store";
import { selectAllPaises } from "../../ubicaciones/entity-paises/entity-paises.selectors";
import { selectAllTiposDocumento } from "../entity-tipos-documento/entity-tipos-documento.selectors";
import { selectAllPaisesDocumento } from "../../ubicaciones/entity-paises-documento/paises-documento.selectors";
import { createDocumentoPersonaSet } from "./documentos-persona.model";

export const selectDocumentoPersonaInitialData = createSelector(
  selectAllPaises,
  selectAllTiposDocumento,
  selectAllPaisesDocumento,
  (paises, tiposDocumento, paisesDocumento) => {
      return createDocumentoPersonaSet({ paises: paises, tiposDocumento: tiposDocumento, paisesDocumento: paisesDocumento })        
  }
);